module.exports = __webpack_public_path__ + "static/media/pwa_install.a2de720e.png";